export const CMS_ITEMS = {
  AIRLINE: "airlines",
};

export const CMS_PARAMS = {
  airline: {
    fields: "name, icon, icon_tail, display_name, short_code",
    limit: `-1`,
    "filter[status][_eq]": "published",
  },
};
